(function () {
  const config = window.pmPortalAuthTrackingConfig || {};
  const storagePrefix = 'pmPortalAuthTracking';
  const pendingTtlMs = 2 * 60 * 1000;

  function storageKey(customerId) {
    return `${storagePrefix}:${customerId || 'anonymous'}`;
  }

  function readState(customerId) {
    try {
      return JSON.parse(window.localStorage.getItem(storageKey(customerId)) || '{}') || {};
    } catch (error) {
      return {};
    }
  }

  function writeState(customerId, state) {
    try {
      window.localStorage.setItem(storageKey(customerId), JSON.stringify(state));
    } catch (error) {
      // Storage can be unavailable in private browsing; tracking should fail quietly.
    }
  }

  function clearState(customerId) {
    try {
      window.localStorage.removeItem(storageKey(customerId));
    } catch (error) {
      // Storage can be unavailable in private browsing; tracking should fail quietly.
    }
  }

  function shouldTrackLogin(state) {
    if (state.loginTrackedAt) return false;

    const pendingAt = Number(state.loginPendingAt || 0);
    if (!pendingAt) return true;

    return Date.now() - pendingAt > pendingTtlMs;
  }

  function postEvent(eventName, options = {}) {
    if (!config.trackUrl) return Promise.resolve(false);

    const body = JSON.stringify({ event: eventName });

    if (options.beacon && navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      return Promise.resolve(navigator.sendBeacon(config.trackUrl, blob));
    }

    return fetch(config.trackUrl, {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: Boolean(options.keepalive),
      headers: {
        'Content-Type': 'application/json',
      },
      body,
    }).then((response) => response.ok);
  }

  function trackLoginOnce() {
    if (!config.isAuthenticated || !config.customerId || !config.trackUrl) return;

    const state = readState(config.customerId);
    if (!shouldTrackLogin(state)) return;

    writeState(config.customerId, {
      ...state,
      loginPendingAt: Date.now(),
    });

    postEvent('login')
      .then((ok) => {
        if (!ok) {
          clearState(config.customerId);
          return;
        }

        writeState(config.customerId, {
          loginTrackedAt: Date.now(),
        });
      })
      .catch(() => {
        clearState(config.customerId);
      });
  }

  function isLogoutLink(link) {
    if (!config.logoutUrl || !link?.href) return false;

    try {
      const linkUrl = new URL(link.href, window.location.origin);
      const logoutUrl = new URL(config.logoutUrl, window.location.origin);
      return linkUrl.pathname === logoutUrl.pathname;
    } catch (error) {
      return link.getAttribute('href') === config.logoutUrl;
    }
  }

  function handleLogoutClick(event) {
    const link = event.target?.closest?.('a[href]');
    if (!isLogoutLink(link)) return;

    if (config.customerId) {
      clearState(config.customerId);
    }

    postEvent('logout', { beacon: true, keepalive: true }).catch(() => {});
  }

  document.addEventListener('click', handleLogoutClick, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackLoginOnce, { once: true });
  } else {
    trackLoginOnce();
  }
})();
